module.exports = "/static/assets/08797dfe44ad94864a999cb3f5db01d6.png";